<template>
    <div class="wrapSQ">
        <!--轮播图-->
        <eazyswiper :type="2"></eazyswiper>
        <div class="content flex-row">
            <!--教育动态-->
            <div class="item-box clearfix">
                <div class="item-title flex-row">
                    <h2>{{ $store.state.navlist[21] }}</h2>
                    <a
                        href="javascript:void(0);"
                        @click="
                            goList(
                                21,
                                $store.state.navlist[2],
                                $store.state.navlist[21]
                            )
                        "
                        class="titleA"
                        >更多&gt;&gt;</a
                    >
                </div>
                <!--公用线-->
                <!-- <div
                    @click="
                        goDetail(
                            itemDataOne,
                            $store.state.navlist[2],
                            $store.state.navlist[21]
                        )
                    "
                    class="item-tw-img"
                >
                    <img :src="itemDataOne.image" :alt="itemDataOne.title" />
                </div> -->
                <!-- <div class="item-tw-text">
                    {{
                        itemDataOne.introduction &&
                        itemDataOne.introduction.length > 120
                            ? itemDataOne.introduction.substring(0, 120) + "..."
                            : itemDataOne.introduction
                    }}
                </div> -->
                <div
                    @click="
                        goDetail(
                            item,
                            $store.state.navlist[2] +
                                '<' +
                                $store.state.navlist[22]
                        )
                    "
                    v-for="(item, index) in itemDataOne"
                    :key="index"
                    class="zixun-item flex-row"
                >
                    <span class="zixun-title">{{ item.title }}</span>
                    <span class="zixun-item-time">{{
                        item.creaTime.time | dateFormat
                    }}</span>
                </div>
            </div>
            <!-- 政策法规 -->
            <div class="item-box clearfix">
                <div class="item-title flex-row">
                    <h2>{{ $store.state.navlist[22] }}</h2>
                    <a
                        href="javascript:void(0);"
                        class="titleA"
                        @click="
                            goList(
                                22,
                                $store.state.navlist[2],
                                $store.state.navlist[22]
                            )
                        "
                        >更多&gt;&gt;</a
                    >
                </div>
                <div
                    @click="
                        goDetail(
                            item,
                            $store.state.navlist[2] +
                                '<' +
                                $store.state.navlist[22]
                        )
                    "
                    v-for="(item, index) in itemDataTwo"
                    :key="index"
                    class="zixun-item flex-row"
                >
                    <span class="zixun-title">{{ item.title }}</span>
                    <span class="zixun-item-time">{{
                        item.creaTime.time | dateFormat
                    }}</span>
                </div>
            </div>
            <!-- 成果展示 -->
            <div class="item-box">
                <div class="item-title flex-row">
                    <h2>{{ $store.state.navlist[23] }}</h2>
                    <a
                        href="javascript:void(0);"
                        class="titleA"
                        @click="
                            goList(
                                23,
                                $store.state.navlist[2],
                                $store.state.navlist[23]
                            )
                        "
                        >更多&gt;&gt;</a
                    >
                </div>
                <div
                    @click="
                        goDetail(
                            item,
                            $store.state.navlist[2] +
                                '<' +
                                $store.state.navlist[23]
                        )
                    "
                    v-for="(item, index) in itemDataThree"
                    :key="index"
                    class="zixun-item flex-row"
                >
                    <span class="zixun-title">{{ item.title }}</span>
                    <span class="zixun-item-time">{{
                        item.creaTime.time | dateFormat
                    }}</span>
                </div>
            </div>
            <!-- 特色品牌 -->
            <div class="item-box">
                <div class="item-title flex-row">
                    <h2>{{ $store.state.navlist[24] }}</h2>
                    <a
                        href="javascript:void(0);"
                        class="titleA"
                        @click="
                            goList(
                                24,
                                $store.state.navlist[2],
                                $store.state.navlist[24]
                            )
                        "
                        >更多&gt;&gt;</a
                    >
                </div>
                <div
                    @click="
                        goDetail(
                            item,
                            $store.state.navlist[2] +
                                '<' +
                                $store.state.navlist[24]
                        )
                    "
                    v-for="(item, index) in itemDataFour"
                    :key="index"
                    class="zixun-item flex-row"
                >
                    <span class="zixun-title">{{ item.title }}</span>
                    <span class="zixun-item-time">{{
                        item.creaTime.time | dateFormat
                    }}</span>
                </div>
            </div>
			 <!-- 特色课程 -->
			<div class="item-box">
			    <div class="item-title flex-row">
			        <h2>{{ $store.state.navlist[25] }}</h2>
			        <a
			            href="javascript:void(0);"
			            class="titleA"
			            @click="
			              goTskc()
			            "
			            >更多&gt;&gt;</a
			        >
			</div>
			    <div
			        @click=" goClassDetails(item)" 
			        v-for="(item, index) in tese"
			        :key="index"
			        class="zixun-item flex-row"
			    >
			        <span class="zixun-title">{{ item.totalTitle }}</span>
			        <span class="zixun-item-time">{{
			            item.creaTime.time | dateFormat
			        }}</span>
			    </div>
                 <!-- <div
			        @click="
			            goDetail(
			                item,
			                $store.state.navlist[2] +
			                    '<' +
			                    $store.state.navlist[25]
			            )
			        "
			        v-for="(item, index) in tese"
			        :key="index"
			        class="zixun-item flex-row"
			    >
			        <span class="zixun-title">{{ item.totalTitle }}</span>
			        <span class="zixun-item-time">{{
			            item.creaTime.time | dateFormat
			        }}</span>
			    </div> -->
			</div>
			 <!-- 特色社区 -->
			<div class="item-box">
			    <div class="item-title flex-row">
			        <h2>{{ $store.state.navlist[26] }}</h2>
			        <a
			            href="javascript:void(0);"
			            class="titleA"
			            @click="
			                goList(
			                    26,
			                    $store.state.navlist[2],
			                    $store.state.navlist[26]
			                )
			            "
			            >更多&gt;&gt;</a
			        >
			    </div>
			    <div
			        @click="
			            goDetail(
			                item,
			                $store.state.navlist[2] +
			                    '<' +
			                    $store.state.navlist[26]
			            )
			        "
			        v-for="(item, index) in itemDataSix"
			        :key="index"
			        class="zixun-item flex-row"
			    >
			        <span class="zixun-title">{{ item.title }}</span>
			        <span class="zixun-item-time">{{
			            item.creaTime.time | dateFormat
			        }}</span>
			    </div>
			</div>
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
    name: "lnjy",
    data() {
        return {
            itemDataOne: {},
            itemDataTwo: {},
            itemDataThree: [],
            itemDataFour: [],
			itemDataFive: [],
            itemDataSix: [],
            tese:[],
        };
    },
    created() {
		// 教育动态
        this.getZixunData(21);
		// 政策法规
        this.getZixunData(22);
		// 教育动态
        this.getZixunData(23);
		// 成果展示
        this.getZixunData(24);
		// 特色课程
		this.getZixunData(25);
		// 特色社区
        this.getZixunData(26);
        // 特色课程  重新写
        this.getCoursesSeries();
    },
    methods: {
		goTskc(){
			this.$router.push({name:'zxkc',query:{classify:1}}) 
		},
        goList(navId, titleOne, titleTwo) {
            this.$router.push({
                name: "articalList",
                query: {
                    id: navId,
                    t1: titleOne,
                    t2: titleTwo
                }
            });
        },
         goClassDetails(val) {
		    this.$router.push({
		        name: "classDetails",
		        query: {
		            id: val.id,
		            title: val.totalTitle,
		            t1: "老年教育",
		            t2: "在线课程"
		        }
		    });
		},
        goDetail(item, title, titleTwo = "") {
            this.$router.push({
                name: "artDetail",
                query: {
                    id: item.id,
                    t1: title,
                    t2: titleTwo ? titleTwo : ""
                }
            });
        },
        getCoursesSeries(){
            this.$ajax({
                method: "post",
                url: "/homePage/getCoursesSeries",
                data: {
                  courseTypeOne: 99,
                },
                success: res => {
                     if (res.code == 200) {
                         if(res.message.records.length> 2) {
                             for(let a = 0; a < 5; a++) {
                                this.tese.push(res.message.records[a])
                            }
                         } else {
                             this.tese = res.message.records
                         }
                     }
                }
            })
        },
        getZixunData(navId, page = 1) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    navigationId: navId,
                    curren: page
                },
                success: res => {
                    // console.log(res);
                    if (res.code == 200) {
                        // console.log(res.message)
                        // console.log(navId)
                        res.message.records.length > 5
                            ? (res.message.records.length = 5)
                            : res.message.records;
                        switch (navId) {
                            case 21:
                                this.itemDataOne = res.message.records
                                    ? res.message.records
                                    : {};
                                break;
                            case 22:
                                this.itemDataTwo = res.message.records
                                    ? res.message.records
                                    : {};
                                break;
                            case 23:
                                this.itemDataThree = res.message.records;
                                break;
                            case 24:
                                this.itemDataFour = res.message.records;
                                break;
							case 25:
							    this.itemDataFive = res.message.records;
							    break;
							case 26:
							    this.itemDataSix = res.message.records;
							    break;
                            default:
                                break;
                        }
                    }
                }
            });
        }
    }
};
</script>
<style scoped="scoped" lang="scss">
.content {
    width: 1000px;
    margin: 0 auto;
    min-height: 500px;
    margin-top: 40px;
    align-items: flex-start;
    align-content: flex-start;
}
/* 图文盒子 */
.item-box:nth-child(odd) {
    margin-right: 60px;
}
.item-box {
    width: 470px;
    margin-bottom: 50px;
    margin-right: 0;
    border: 0;
    display: inline-block;
    position: relative;
    .item-title {
        width: 100%;
        color: #595959;
        height: 40px;
        padding: 0;
        justify-content: space-between;
        border-bottom: 2px solid #ddd;
        margin-bottom: 10px;
        h2 {
            position: relative;
            height: 20px;
            line-height: 20px;
            padding: 10px 0;
            border-bottom: 2px solid #6ac0e8;
            display: inline-block;
            z-index: 1;
            font-size: 18px;
            font-weight: bold;
        }
        a {
            line-height: 40px;
            font-size: 16px;
            color: #6ac0e8;
        }
    }
    // 图文信息
    .item-tw-img {
        width: 158px;
        height: 185px;
        float: left;
        margin: 5px 0;
        border: 1px solid #ddd;
        box-sizing: border-box;
        transition: all ease 0.3s;
        overflow: hidden;
        img {
            width: 100%;
            min-height: 100%;
            overflow: hidden;
        }
    }
    .item-tw-img:hover {
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    }
    .item-tw-text {
        display: inline-block;
        width: 300px;
        max-height: 185px;
        float: right;
        margin: 5px 0;
        overflow: hidden;
        line-height: 23px;
        a {
            font-size: 14px;
            color: #6ac0e8;
        }
    }
    // 信息
    .zixun-item {
        justify-content: space-between;
        cursor: pointer;
        .zixun-title {
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 5px 0;
            flex: 1;
            overflow: hidden;
        }
        .zixun-item-time {
            float: right;
            font-size: 14px;
            color: #999;
        }
    }
    .zixun-item:hover > .zixun-item-time {
        color: #333 !important;
    }
    .zixun-item:hover > .zixun-title {
        color: #333 !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/sqjy/sqjy.vue